import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  FaChartLine,
  FaShieldAlt,
  FaHandshake,
  FaEuroSign,
  FaWallet,
  FaSlidersH,
} from "react-icons/fa";
import "./Module2.css";
import "./styles.css";
import { useEffect, useState } from "react";
import CalendlyButton from './components/CalendlyButton';

const Module2 = () => {
  function ResponsiveTitle() {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
      };

      window.addEventListener("resize", handleResize);
      handleResize();

      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return isMobile ? (
      <h4
        className="text-center fw-bold special-font"
        style={{ letterSpacing: "5px", lineHeight: "24px" }}
      >
        POR QUE O MERCADO IMOBILIÁRIO É A MELHOR ESCOLHA?
      </h4>
    ) : (
      <h3
        className="text-center fw-bold special-font"
        style={{
          letterSpacing: "8px",
          lineHeight: "32px", // resolvendo o problema
        }}
      >
        POR QUE O MERCADO IMOBILIÁRIO <br /> É A MELHOR ESCOLHA?
      </h3>
    );
  }

  return (
    <div className="bg-white">
      <div className="p-5 container-sm">
        <ResponsiveTitle />

        <p
          className="text-start mt-5 "
          style={{ fontSize: "18px", color: "#111", letterSpacing: "1.8px" }}
        >
          <span className="fw-bold">Imóveis sempre terão valor.</span> Enquanto
          empresas podem falir e ações podem despencar, terra e propriedades
          continuam sendo ativos escassos e essenciais.
        </p>
        <p
          className=" text-start mt-4"
          style={{ fontSize: "18px", color: "#111", letterSpacing: "1.8px" }}
        >
          <span className="fw-bold">Valorização + Renda Passiva.</span> Investir
          em imóveis permite ganhar dinheiro duas vezes: na valorização e na
          renda gerada por aluguéis ou revenda.
        </p>
        <p
          className=" text-start mt-4"
          style={{ fontSize: "18px", color: "#111", letterSpacing: "1.8px" }}
        >
          <span className="fw-bold">Segurança e previsibilidade.</span>{" "}
          Diferente da bolsa, onde uma crise pode destruir ganhos de anos, o
          mercado imobiliário permite projeções seguras e estratégias de
          crescimento controladas.
        </p>

        <div className="container col-12 col-md-9">
          <p
            className="text-center mt-5 special-font"
            style={{
              fontSize: "18px",
              letterSpacing: "1px",
              color: "#111",
              border: "2px solid #ECA600",
              borderRadius: "10px",
              padding: "20px",
              backgroundColor: "#fff9ec", // leve destaque visual
            }}
          >
            <span
              className="fw-bold"
              style={{ color: "black", letterSpacing: "1.8px" }}
            >
              PORÉM, as melhores oportunidades não estão disponíveis para todo
              mundo.
            </span>
            <br />
            <span style={{ letterSpacing: "1.8px" }}>
              Elas surgem para quem está inserido no mercado, tem acesso a
              informações privilegiadas e sabe onde agir na hora certa.
            </span>
          </p>
        </div>
        <div
  className="container col-12 col-md-9 mt-5"
  style={{
    backgroundColor: "#111111",
    borderRadius: "12px",
    padding: "30px 20px",
    boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.4)",
  }}
>
  <p
    className="text-center special-font text-white"
    style={{
      fontSize: "clamp(18px, 5vw, 26px)", // responsivo
      letterSpacing: "1px",
      lineHeight: "34px",
      marginBottom: "15px",
    }}
  >
    E foi exatamente por isso que nasceu a <br />
    <span
      className="fw-bold"
      style={{
        fontSize: "clamp(24px, 7vw, 42px)", // responsivo
        letterSpacing: "2px",
        color: "#ECA600",
      }}
    >
      IMO INVESTIMENTOS
    </span>
  </p>

  <p
    className="text-center special-font text-white"
    style={{
      fontSize: "clamp(16px, 4.5vw, 20px)", // responsivo
      letterSpacing: "1.5px",
      lineHeight: "32px",
      maxWidth: "800px",
      margin: "0 auto",
    }}
  >
    com a missão de{" "}
    <span className="fw-bold">
      universalizar o acesso a investimentos imobiliários de alta rentabilidade
      para brasileiros.
    </span>
  </p>
</div>



      </div>

      <div
        className="p-4"
        style={{ backgroundColor: "black", paddingTop: "50px" }}
      >
        <div className="container"></div>
      </div>

      <div style={{ backgroundColor: "black", paddingTop: "30px" }}>
        <h3
          className="text-white text-center special-font fw-bold"
          style={{
            letterSpacing: "8px",
            lineHeight: "26px",
          }}
        >
          POR QUE INVESTIDORES ESCOLHEM <br /> A IMO?
        </h3>

        <div className="container py-5">
          <div className="row text-center gy-4">
            {/* DNA Estratégico */}
            <div className="col-12 col-md-4">
              <div className="feature-box">
                <FaChartLine size={65} style={{ color: "#ECA600" }} />
                <h5 className="mt-3">DNA ESTRATÉGICO</h5>
                <p>
                  Abordagem estratégica baseada em análise profunda de cenários
                  e identificação das melhores oportunidades, com foco em
                  maximizar o retorno ajustado ao risco.
                </p>
              </div>
            </div>

            {/* Transparência */}
            <div className="col-12 col-md-4">
              <div className="feature-box">
                <FaShieldAlt size={65} style={{ color: "#ECA600" }} />
                <h5 className="mt-3">TRANSPARÊNCIA TOTAL</h5>
                <p>
                  Total transparência em todas as fases dos projetos, com
                  validação prévia das premissas e projeções, assegurando
                  clareza sobre retornos e riscos.
                </p>
              </div>
            </div>

            {/* Rentabilidade Sustentável */}
            <div className="col-12 col-md-4">
              <div className="feature-box">
                <FaWallet size={65} style={{ color: "#ECA600" }} />
                <h5 className="mt-3">RENTABILIDADE SUSTENTÁVEL</h5>
                <p>
                  Projetos estruturados para gerar retornos consistentes e
                  sustentáveis, com expectativa de retorno anual entre 8% e 25%.
                </p>
              </div>
            </div>

            {/* Confiabilidade */}
            <div className="col-12 col-md-4">
              <div className="feature-box">
                <FaHandshake size={65} style={{ color: "#ECA600" }} />
                <h5 className="mt-3">CONFIABILIDADE</h5>
                <p>
                  Segurança jurídica rigorosa, com contratos blindados e
                  mecanismos de garantia, protegendo o capital do investidor.
                </p>
              </div>
            </div>

            {/* Investimento em Euro */}
            <div className="col-12 col-md-4">
              <div className="feature-box">
                <FaEuroSign size={65} style={{ color: "#ECA600" }} />
                <h5 className="mt-3">INVESTIMENTO EM EURO</h5>
                <p>
                  Investimentos denominados em EURO, uma moeda forte e estável,
                  protegendo contra riscos cambiais, políticos e econômicos.
                </p>
              </div>
            </div>

            {/* Diversificação */}
            <div className="col-12 col-md-4">
              <div className="feature-box">
                <FaSlidersH size={65} style={{ color: "#ECA600" }} />
                <h5 className="mt-3">DIVERSIFICAÇÃO</h5>
                <p>
                  Estratégias diversificadas que equilibram segurança e retorno,
                  atendendo a diferentes perfis e objetivos de investimento.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* <div
          className="d-flex justify-content-center align-items-center"
          style={{ backgroundColor: "black" }}
        >
          <button
            className="btn border-0 mb-5 px-5 py-3 fw-bold"
            style={{
              backgroundColor: "#ECA600",
              letterSpacing: "1.8px",
              borderRadius: "50px",
              fontSize: "1.1rem",
              color: "black",
              transition: "all 0.3s ease",
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#f0b000";
              e.target.style.color = "#fff";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "#ECA600";
              e.target.style.color = "black";
            }}
          >
            INVISTA COM A IMO
          </button>
        </div> */}
        <div className="mb-4">
        
              <CalendlyButton label="INVISTA COM A IMO" />
            </div>
      </div>
    </div>
  );
};

export default Module2;
